<template>
  <div v-if="npsRating !== null" class="columns is-pulled-right nps-component">

    <div class="nps-rating-desktop-tablet" :class="{bigIcon:bigSize}">
      <div
          v-if="npsRating >= 0 && npsRating < 7"
          class="column is-1 detractors nps-block">
        <span class="is-hidden-mobile">{{ detractors.title }}</span>
        <v-popover
            trigger="click"
            placement="top-start"
            offset="60"
            :popoverClass="popoverClass"
        >
          <i class="is-pulled-right is-fixed-top fas fa-info-circle"></i>
          <template slot="popover">
            <p>{{detractors.content}}</p>
          </template>
        </v-popover>
      </div>

      <div
          v-else-if="npsRating > 6 && npsRating < 9"
          class="column is-1 passives nps-block">
        <span class="is-hidden-mobile">{{ passives.title }}</span>
        <v-popover
            trigger="click"
            placement="top-start"
            offset="60"
            :popoverClass="popoverClass"
        >
          <i class="is-pulled-right is-fixed-top fas fa-info-circle"></i>
          <template slot="popover">
            <p>{{ passives.content }}</p>
          </template>
        </v-popover>
      </div>

      <div
          v-else-if="npsRating > 8 && npsRating <= 10"
          class="column is-1 promoters nps-block">
        <span class="is-hidden-mobile">{{promoters.title}}</span>
        <i v-tooltip="promoters" class="is-pulled-right is-fixed-top fas fa-info-circle"></i>
        <v-popover
            trigger="click"
            placement="top-start"
            offset="60"
            :popoverClass="popoverClass"
        >
          <i class="is-pulled-right is-fixed-top fas fa-info-circle"></i>
          <template slot="popover">
            <p>{{ promoters.content }}</p>
          </template>
        </v-popover>
      </div>
    </div>

  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import misc from '../mixins/misc.js'
  export default {
    name: 'nps',
    mixins: [misc],
    props: {
        npsRating: {
            type: Number,
            default: 0
        },
        bigSize: {
          type: Boolean,
          default: false
        }
    },
    data: function () {
      return {
        detractors: {
            title: 'Unhappy customer',
            content: 'This customer wasn’t happy with their interaction with this business and would not recommend this business.'
        },
        passives: {
            title: 'Undecided customer',
            content: 'This customer was happy with this business, but thinks there is room for improvement. They are still likely to recommend this business.'
        },
        promoters: {
            title: 'Happy customer',
            content: 'This customer enjoyed dealing with this business, is satisfied and is very likely to recommend this business.'
        }
      }
    },
    computed:{
      popoverClass(){
        return (this.bigSize)?'bigIcon':''
      }
    }
  }
</script>
<style scoped>
  .detractors, .passives, .promoters {
    display: block;
    height: 30px;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 30px 30px;
    text-align: center;
    font-size: 11.2px;
    padding: 32px 0 0 0;
    min-width: 100%;
    margin-top:15px;
  }

  .detractors {
    background-image: url("/static/img/reviews/detractors.svg");
  }

  .passives {
    background-image: url("/static/img/reviews/passives.svg");
  }
  .promoters {
    background-image: url("/static/img/reviews/promoters.svg");
  }
  .nps-component {
    min-width: 110px;
    justify-content: center;
  }
  .nps-rating-desktop-tablet {
    width: 100%;
  }
  .nps-rating-desktop-tablet i {
    font-size: 14px;
  }
  .nps-rating-desktop-tablet {
    position: relative;
  }
  .is-fixed-top{
    position: absolute;
    right: 20px;
    top: 15px;
  }

  .bigIcon .is-fixed-top{
    right: 15px;
  }

  @media screen and (max-width: 767px) {
    .nps-component {
      min-width: 65px;
    }
    .is-fixed-top{
      top: 0;
    }
    .bigIcon .is-fixed-top{
      right: -5px;
    }
    .nps-component {
      position: absolute;right: 0;
    }
    .nps-component .promoters{
      margin-top: 20px;
    }
    .nps-component .fa-info-circle.has-tooltip {
      top: 0;right: 15%; display:none;
    }
    . nps-rating-desktop-tablet .nps-block .fa-info-circle {
      display:none !important;
    }
  }

  @media screen and (min-width: 768px) {
    .bigIcon .detractors, .bigIcon .passives, .bigIcon .promoters {
      height: 45px;
      background-size: 45px 45px;
      padding-top: 47px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NPS.vue